import { HTMLAttributes } from "react"

import { Translate } from "../translate"
import { BaseTypographyProps } from "./types"

/* -------------------------------------------------------------------------------------------------
 * types
 * -----------------------------------------------------------------------------------------------*/

type H3Props = BaseTypographyProps & HTMLAttributes<HTMLHeadingElement>

/* -------------------------------------------------------------------------------------------------
 * component
 * -----------------------------------------------------------------------------------------------*/

const H3 = ({ i18nKey, values, formats, ...props }: H3Props) => {
  return (
    <h3 {...props}>
      <Translate i18nKey={i18nKey} values={values} formats={formats} />
    </h3>
  )
}

export { H3 }
